module.exports = __webpack_public_path__ + "static/media/YM27_1.64dda123.jpg";